<div *ngIf="showRequest" class="" >
  <h2 class="sectionTitle" >{{ 'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.Title' | translate }}</h2>

  <form [formGroup]="BidSubscriptionForm" (ngSubmit)="onSubmit()" >


      <div class="form-container">

           <!--BidType-->
           <div class="form-group">
            <label for="SupplierBidSubsriptionTypeId">{{'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.BidType' | translate}}</label>
            <span class="red"> *</span>
            <select  id="SupplierBidSubsriptionTypeId" name="SupplierBidSubsriptionTypeId" class="form-control"
              formControlName="SupplierBidSubsriptionTypeId">
              <option [value]="null" selected>{{ 'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.CHOOSE_BID' | translate }}
              </option>
               <ng-container *ngFor="let bidtype of supplierBidSubsriptionTypes">
                <option *ngIf="displayedLang=='NameEN'" [value]="bidtype.Id">
                  {{bidtype.NameEN}}
                </option>
                <option *ngIf="displayedLang=='NameAR'" [value]="bidtype.Id">
                  {{bidtype.NameAR}}
                </option>
              </ng-container>
            </select>
            <div *ngIf="submitted && (Validate.SupplierBidSubsriptionTypeId?.errors||Validate.SupplierBidSubsriptionTypeId?.value=='null')" class="red">
              <div *ngIf="Validate.SupplierBidSubsriptionTypeId?.errors?.required||Validate.SupplierBidSubsriptionTypeId?.value=='null'">
                {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
            </div>
          </div>

        <!--Name-->
        <div class="form-group">
          <label for="SupplierName">{{ 'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.Name' | translate }}</label>
          <span class="red"> *</span>
          <input type="text"  id="SupplierName"  name="SupplierName" class="form-control" formControlName="SupplierName"/>
          <div *ngIf="submitted && Validate.SupplierName?.errors" class="red ">
            <div *ngIf="Validate.SupplierName?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>

          <div *ngIf="Validate.SupplierName?.errors?.maxlength">
            {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}
          </div>
          <div *ngIf="Validate.SupplierName?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
          </div>
          <div *ngIf="Validate.SupplierName?.errors?.pattern">
            {{'ADMIN_USER.SHARED.PATTERN' | translate}}
          </div>
        </div>
        </div>


        <!--Address-->
        <div class="form-group">
          <label for="SupplierAddress">{{ 'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.Address' | translate}}</label>
          <span class="red"> *</span>
          <textarea formControlName="SupplierAddress" name="SupplierAddress" class="form-control" ></textarea>
          <div *ngIf="submitted && Validate.SupplierAddress?.errors" class="red ">
            <div *ngIf="Validate.SupplierAddress?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              <div *ngIf="Validate.SupplierAddress?.errors?.maxlength">
                {{'FRONT_USER.TEXT_MAX_LENGTH_200_ERROR' | translate}}
              </div>
              <div *ngIf="Validate.SupplierAddress?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div>
              <div *ngIf="Validate.SupplierAddress?.errors?.pattern">
                {{'ADMIN_USER.SHARED.PATTERN' | translate}}
              </div>
          </div>
        </div>

        <!--Phone-->
        <!--<div class="form-group">
            <label for="SupplierPhone">{{ 'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.Phone' | translate }}</label>
            <span class="red"> *</span>
            <ngx-intl-tel-input [enableAutoCountrySelect]="true" [enablePlaceholder]="true" id="SupplierPhone"
              name="SupplierPhone" formControlName="SupplierPhone"></ngx-intl-tel-input>
            <div *ngIf="submitted ||(Validate.SupplierPhone?.dirty && Validate.SupplierPhone?.errors)" class="red">
              <div *ngIf="Validate.SupplierPhone?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |translate}}</div>
              <div *ngIf="Validate.SupplierPhone?.errors?.validatePhoneNumber" class="red">
                {{'FRONT_USER.REGISTRATION_FORM.VALID_PHONE_NUMBER' | translate}}</div>
            </div>
          </div>-->




         <div class="form-group">
          <label for="SupplierPhone">{{ 'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.Phone' | translate}}</label>
          <span class="red"> *</span>
          <input type="text" formControlName="SupplierPhone" name="SupplierPhone" class="form-control" />
          <div *ngIf="submitted ||(Validate.SupplierPhone?.dirty && Validate.SupplierPhone?.errors)" class="red">
            <div *ngIf="Validate.SupplierPhone?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |translate}}</div>
            <div *ngIf="Validate.SupplierPhone?.errors?.validatePhoneNumber" class="red">
              {{'FRONT_USER.REGISTRATION_FORM.VALID_PHONE_NUMBER' | translate}}</div>
          </div>
        </div>

         <!--Email-->
        <div class="form-group">
        <label for="SupplierEmail">{{ 'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.Email' | translate}}</label>
        <input type="text" formControlName="SupplierEmail" id="SupplierEmail" name="SupplierEmail" class="form-control" placeholder="example@domain.com" />
        <div *ngIf="submitted && Validate.SupplierEmail?.errors" class="red ">
          <div *ngIf="Validate.SupplierEmail?.errors?.email">
            {{ 'FRONT_USER.ERRORS_MESSAGES.InvalidEmail' | translate }}</div>
        </div>
      </div>

        <!--Fax-->
        <div class="form-group">
          <label for="SupplierFax">{{ 'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.Fax' | translate}}</label>
          <span class="red"> *</span>
          <input type="text" formControlName="SupplierFax" id="SupplierFax" name="SupplierFax" class="form-control" />
          <div *ngIf="submitted && Validate.SupplierFax?.errors" class="red ">
            <div *ngIf="Validate.SupplierFax?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
              <div *ngIf="Validate.SupplierFax?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
            </div>
          </div>
        </div>



    </div>
    <!-- </div> -->
    <div class="form-group" >

      <button title="{{ 'FRONT_USER.SAVE' | translate}}" [disabled]="loading" class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate}}
      </button>
    </div>
  </form>
</div>

<!-- Confirmation -->
<div *ngIf="!showRequest" class="alert alert-success" role="alert">
  <div class="alignC">
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g>
              <g>
                  <path d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z"></path>
              </g>
          </g>
      </svg>
      <p> {{ 'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.SuccessMsg' | translate }}
       </p>
      <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace"> {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>


